import React from 'react';
import clsx from 'classnames';
import './index.css';
import Banner from './components/Banner';
import Detection from './components/Detection';
import Laboratory from './components/Laboratory';
import Case from './components/Case';
import { usePageTitle } from '../../hooks';

const Business = () => {
  // 设置页面标题
  usePageTitle('业务方案');
  return (
    <div
      className={clsx('business-top')}
      style={{ minHeight: window.innerHeight }}
    >
      {/* 顶部Banner */}
      <Banner />
      {/* 检测业务 */}
      <Detection />
      {/* 专业实验室 */}
      <Laboratory />
      {/* 服务案例 */}
      <Case />
    </div>
  );
};

export default Business;
